export const bookingDraftKey = (eventId) =>
  `mass_ticketing_booking_draft_${eventId}`;

export const loadBookingDraft = (eventId) => {
  try {
    const raw = sessionStorage.getItem(bookingDraftKey(eventId));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const persistBookingDraft = (eventId, draft) => {
  try {
    sessionStorage.setItem(bookingDraftKey(eventId), JSON.stringify(draft));
  } catch (_) {
    /* ignore quota / privacy mode */
  }
};

export const clearBookingDraft = (eventId) => {
  if (eventId == null || eventId === "") return;
  try {
    sessionStorage.removeItem(bookingDraftKey(eventId));
  } catch (_) {
    /* ignore */
  }
};

export const isPaymentRedirectSuccess = (search) => {
  if (!search) return false;
  try {
    const params = new URLSearchParams(
      search.startsWith("?") ? search.slice(1) : search
    );
    const success = params.get("success");
    return success === "true" || success === "1";
  } catch {
    return false;
  }
};

export const clearBookingDraftAfterPayment = (eventId, paymentStatus, search) => {
  if (eventId == null || eventId === "") return;
  const paymentSucceeded =
    paymentStatus === "paid" || isPaymentRedirectSuccess(search);
  if (paymentSucceeded) {
    clearBookingDraft(eventId);
  }
};
